export default {
  chargers: {
    locationFromIp: null,
    geolocation: null,
    all: [],
    byId: {},
    reviewsById: {},
    imagesById: {},
    filters: {
      superchargers: true,
      destinationChargers: true,
    },
    filteredChargers: [],
    mappedChargers: [],
    chargerMap: {
      center: {
        lat: 39.8282,
        lng: -98.5795,
      },
      zoom: 4,
      selectedCharger: null,
    },
    centerOnCurrentLocation: true,
    nearUser: {
      ids: [],
      pagination: {
        next: null,
        previous: null,
      },
    },
    chargersPagination: {},
    cache: {},
    countries: [],
    countriesById: {},
    states: [],
    statesById: {},
    ranked: [],
    showPlaceCategories: ['restaurant'],
  },
  places: {
    byId: {},
    reviewsById: {},
    categories: {},
  },
  users: {
    byId: {},
    byUsername: {},
  },
  auth: {
    isLoggedIn: false,
    currentUser: null,
    loggingIn: false,
    error: null,
    passwordReset: null,
  },
  locale: {
    language: 'en',
    languages: ['en'],
    imperialUnits: false,
  },
  pages: {
    bySlug: {
      about: {
        title: 'About',
        loaded: false,
      },
      privacy: {
        title: 'Privacy Policy',
        loaded: false,
      },
      contact: {
        title: 'Contact',
        loaded: false,
      },
    },
  },
};



// WEBPACK FOOTER //
// ./app/scripts/config/initialState.js